export const AlertColors = Object.freeze({
  SUCCESS: "#26d43a",
  DEBUG: "#9d9fa0",
  LOG: "#e0e0e0",
  INFO: "#737171",
  WARNING: "#fcb447",
  ERROR: "#c53c3c",
  CONFIG: "#e0e0e0",
  CRITICAL: "#DC4EF2",
  PENDING: "#2196f3"
});

export const AlertLevelClass = Object.freeze({
  DEBUG: -1,
  LOG: 0,
  INFO: 1,
  WARNING: 2,
  ERROR: 3,
  CRITICAL: 4,
});

export const AlertIcons = Object.freeze({
    DEBUG: -1,
    INFO: 0,
    WARNING: 1,
    ERROR: 2,
    SETTINGS: 3,
    CRITICAL: 4
})

export function levelToClass(level) {
    return Math.floor(level / 10)
}

